<template>
  <div class="tariff-option-icon-wrapper">
    <div class="tariff-option-icon">
      <span class="text-sm-semibold">{{ value }}</span>
    </div>
    <img src="/files/lidl/images/new-icons/svg/tariff_option_data.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'TariffOptionsIcon',
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>
